import { useEffect, useState } from "react"

// Catches errors ErrorBoundary can't — those thrown outside React's render
// phase, e.g. from event handlers, effects, or rejected promises — and
// shows them on-screen instead of leaving a silent blank page.
export function GlobalErrorOverlay() {
  const [message, setMessage] = useState<string | null>(null)

  useEffect(() => {
    function handleError(event: ErrorEvent) {
      setMessage(`${event.message}\n${event.error?.stack ?? ""}`)
    }
    function handleRejection(event: PromiseRejectionEvent) {
      const reason = event.reason
      setMessage(reason instanceof Error ? `${reason.message}\n${reason.stack}` : String(reason))
    }
    window.addEventListener("error", handleError)
    window.addEventListener("unhandledrejection", handleRejection)
    return () => {
      window.removeEventListener("error", handleError)
      window.removeEventListener("unhandledrejection", handleRejection)
    }
  }, [])

  if (!message) return null

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        background: "#fff",
        color: "#c00",
        padding: 16,
        fontFamily: "monospace",
        fontSize: 13,
        whiteSpace: "pre-wrap",
        wordBreak: "break-all",
        overflow: "auto",
      }}
    >
      <h1 style={{ fontSize: 16 }}>予期しないエラー</h1>
      <pre>{message}</pre>
    </div>
  )
}
